/* Page to display the links to find Posts 
   by Department */
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import {
  useSetCategoryContext,
  useSetDeptContext,
} from "../../contexts/DeptCategoryContext";
import TopBox from "../../components/TopBox";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import EpisodeList from "../episodes/EpisodeList";
import { axiosInstance } from "../../api/axiosDefaults";
import btnStyles from "../../styles/Button.module.css";
import styles from "../../styles/Scene.module.css";

const FindPostsDepartmentEpisode = () => {
  // useRedirect();
  const setDept = useSetDeptContext();
  const setCategory = useSetCategoryContext();
  const callEpi = true;
  const history = useHistory();
  const currentUser = useCurrentUser();
  const [episodes, setEpisodes] = useState([]);

  const queryString = window.location.search;
  // Television
  const projectType =
    currentUser?.project_category_type &&
    JSON.parse(currentUser.project_category_type);

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const fetchEpisodes = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${localStorage.getItem("projectSlug")}/scene_episodes/`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      setEpisodes(data.results);
    } catch (error) {
      console.log("fetch series error: ", error);
    }
  };

  useEffect(() => {
    fetchEpisodes();
  }, []);

  const getLink = useCallback((episode) => {
    // Add null/undefined check for episode
    if (!episode) return "/";

    return `/${localStorage.getItem(
      "projectSlug"
    )}/findposts/departments?episode=${episode.id}&project=${
      episode.project
    }&episodeTitle=${encodeURIComponent(episode.episode_number)}`;
  }, []);

  return (
    <div>
      <TopBox title="Quick Find Posts" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <h3 className="text-center">Select Episode</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      {/* Episode layer */}
      <EpisodeList
        episodes={episodes}
        currentUser={currentUser}
        callEpi={callEpi}
        getLink={getLink}
      />
    </div>
  );
};

export default FindPostsDepartmentEpisode;
